import React, { useState } from "react";
import { Bell, Menu } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/hooks/useAuth";
import NotificationPanel from "../../../components/ui/NotificationPanel";

// ── Mock notifications ────────────────────────────────────────────────────────
const NOTIFICATIONS = [
  { id: 1, text: "New Enterprise request",        time: "22 hours ago" },
  { id: 2, text: "New user registered",            time: "1 day ago"    },
  { id: 3, text: "Payment received from TechCorp", time: "2 days ago"   },
];

// ── Topbar ────────────────────────────────────────────────────────────────────
const AdminTopbar = ({ onToggleSidebar }) => {
  const { state } = useAuth();
  const navigate  = useNavigate();
  const user      = state.user || {};

  const [notifOpen, setNotifOpen] = useState(false);

  const initials = (user.name || "AD")
    .split(" ")
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  const displayName = user.name || "Admin";

  return (
    <>
      <header className="h-16 bg-white border-b border-surface-border flex items-center justify-between px-4 sm:px-6 gap-4 flex-shrink-0 relative z-30">
        <button
          onClick={onToggleSidebar}
          className="lg:hidden flex items-center justify-center w-9 h-9 rounded-lg text-brand-muted hover:bg-surface transition-colors"
          aria-label="Toggle sidebar"
        >
          <Menu className="w-5 h-5" />
        </button>

        <div className="flex-1" />

        {/* Bell */}
        {/* <button
          onClick={() => setNotifOpen((o) => !o)}
          className="relative w-9 h-9 rounded-full flex items-center justify-center text-brand-muted hover:bg-surface transition-colors"
          aria-label="Notifications"
        >
          <Bell className="w-5 h-5" />
          {NOTIFICATIONS.length > 0 && (
            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-primary rounded-full" />
          )}
        </button> */}

        {/* Admin avatar — navigates to profile */}
        <button
          onClick={() => navigate("/admin/profile")}
          className="flex items-center gap-2 rounded-lg px-1 py-0.5 hover:bg-surface transition-colors"
          aria-label="Go to profile"
        >
          <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center text-white text-xs font-bold select-none flex-shrink-0">
            {initials}
          </div>
          <span className="hidden sm:block text-sm font-medium text-brand-text">{displayName}</span>
        </button>
      </header>

      {notifOpen && (
        <NotificationPanel
          notifications={NOTIFICATIONS}
          onClose={() => setNotifOpen(false)}
        />
      )}
    </>
  );
};

export default AdminTopbar;
